const contentNewLine = {
    props: { value: { type: String, default: '' } },
    render(h) {
        return h(
            'div',
            (this.value || '')
                .split(/\n/)
                .map(c => [this._v(c), h('br')])
                .flat()
        );
    }
};

export default contentNewLine;
